<div class="analysis-table-container">
  <table class="analysis-table">
    <thead>
      <tr>
        <th class="col-key">Provision</th>
        <th class="col-risk">Risk</th>
        <th class="col-risk">Coverage</th>
        <th class="col-content">Finding</th>
      </tr>
    </thead>
    <tbody>
      @for (c of comparisons; track c.provNum) {
        <tr>
          <td class="col-key">
            <strong>{{ c.provName }}</strong>
          </td>
          <td class="col-risk">
            <mat-chip [class]="riskClass(c.riskScore)">{{ c.riskScore }}</mat-chip>
          </td>
          <td class="col-risk">
            {{ c.coverage }}
          </td>
          <td class="col-content">
            <p class="action-text" [class.high-priority]="c.riskScore === 'high'">
              {{ c.rationale }}
            </p>
            @if (c.contractExcerpt) {
              <p class="analysis-excerpt">"{{ c.contractExcerpt }}"</p>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
